export const nn = {
  antalltimer: "Antal timar",
  ansettelsesform: "Tillsettingsform",
  ansettelsesperiode: "Tilsettingsperiode",
  apne: "Opne",
  arbeidsavtale: "Arbeidsavtale",
  arbeidsforhold: "Arbeidsforhold",
  arbeidsforholdid: "Arbeidsforhold ID",
  arbeidstidsordning: "Arbeidstidsordning",
  endretstillingsprosent: "Endra stillingsprosent",
  fartsomraade: "Fartsområde",
  generelleopplysninger: "Generelle opplysningar",
  httperror: "Oi, noko gjekk galt ved henting av data!",
  hovedenhet: "Hovudeining",
  hvisfeil1: `Oversikta viser arbeidsforholda slik dei er rapportert av arbeidsgivar.`,
  hvisfeil2: `Dersom det er feil i et arbeidsforhold, kan arbeidsgivaren endre gjennom a-meldinga.`,
  ingenarbeidsforhold: `Du har ingen registrerte arbeidsforhold.`,
  land: "Land",
  lonnsendring: "Lønsendring",
  lukke: "Lukk",
  organisasjonsnummer: "Organisasjonsnummer",
  opptjeningsperiode: "Oppteningsperiode",
  navaerendejobb: "Noverande jobb",
  periode: "Periode",
  prosent: " Prosent",
  rapporteringsperiode: "Rapporteringsperiode",
  side: "Side",
  sistbekreftet: "Sist bekrefta av arbeidsgivar",
  sistelonnsendring: "Siste lønsendring",
  skipsregister: "Skipsregister",
  skipstype: "Skipstype",
  skrivut: "Skriv ut",
  sluttaarsak: "Sluttårsak",
  stillingsprosent: "Stillingsprosent",
  tabs: {
    arbeidiutlandet: "Arbeid i utlandet",
    historikk: "Historikk",
    permisjonpermittering: "Permisjon/Permittering",
    timerfortimelonnet: "Timar for timeløna",
  },
  timerifullstilling: "Timar i full stilling",
  timerperuke: "Timar/veke",
  tilleggsopplysninger: "Vel kva tilleggsopplysningar du vil skrive ut",
  type: "Type",
  typearbeidsforhold: "Type arbeidsforhold",
  utskriftsvalg: "Utskriftsval",
  visfaerrearbeidsforhold: "Vis færre arbeidsforhold",
  visflerearbeidsforhold: "Vis fleire arbeidsforhold",
  yrke: "Yrke",
  pdfFooter1: `Oversikta viser arbeidsforholda slik dei er rapportert til Arbeidsgivar- og arbeidstakarregisteret`,
  pdfFooter2: (date: string) =>
    `Arbeids- og velferdsetaten // Utskrift frå ${date}`,
  ERKONK:
    "Arbeidsgivaren har gått konkurs. NAV har satt same sluttdato som konkursopningsdato i Konkursregisteret.",
  EROPPH:
    "Føretaket er opphøyrt i Enhetsregisteret. NAV har satt same sluttdato som datoen føretaket opphøyrte i Enhetsregisteret.",
  ERVIRK:
    "Føretaket er overdratt til ei anna juridisk eining. NAV har satt  same sluttdato som datoen då føretaket ble overdratt i Enhetsregisteret.",
  IBARBG:
    "Arbeidsgivaren har ikkje stadfesta arbeidsforholdet. NAV har derfor satt sluttdato til siste dato i den kalendermånaden arbeidsgivaren din sist stadfesta arbeidsforholdet.",
  IBKAOR:
    "Sluttdato satt av NAV. Arbeidsforholdet er ikkje stadfesta gjennom a-ordningen. Sluttdato er satt til 31.12.2014",
};
